import {
  LayerTimeRangeControl,
  LayerTimeRangeControlMessage,
} from './LayerTimeRangeControl';
import type { ExternalLayer } from 'hooks/externalLayer/types';
import { useSharedTnGuardLayerTimeRange } from './utils/useSharedTnGuardLayerTimeRange';

type SharedTnGuardLayerTimeControlProps = {
  layers: ExternalLayer[];
};

/**
 * Shared start/stop datetime pickers + dual range slider for Ting Outages and
 * FloodingBins Demo. Mounted at the top of the Layers tab.
 */
export function SharedTnGuardLayerTimeControl({
  layers,
}: SharedTnGuardLayerTimeControlProps) {
  const {
    start,
    end,
    setStart,
    setEnd,
    setRangeFromSlider,
    fullStart,
    fullEnd,
    status,
    message,
  } = useSharedTnGuardLayerTimeRange(layers);

  if (status === 'hidden') {
    return null;
  }

  if (status === 'loading') {
    return (
      <LayerTimeRangeControlMessage message="Loading shared time range…" />
    );
  }

  if (status === 'unavailable' || !fullStart || !fullEnd || !start || !end) {
    return (
      <LayerTimeRangeControlMessage
        message={message || 'Time info unavailable for Tennessee Guard layers.'}
      />
    );
  }

  return (
    <LayerTimeRangeControl
      start={start}
      end={end}
      fullStart={fullStart}
      fullEnd={fullEnd}
      onStartChange={setStart}
      onEndChange={setEnd}
      onRangeFromSlider={setRangeFromSlider}
      title="Layer time range"
      subtitle="Applies to Ting Outages and FloodingBins Demo"
      idPrefix="tn-guard-time"
    />
  );
}
